import pathOr from 'ramda/es/pathOr';

export default data => pathOr('-', ['headers', 'x-b3-traceid'])(data);
